module.exports = __webpack_public_path__ + "e472b7d1c20cdc5728931bf65738fc01.svg";